module.exports = __webpack_public_path__ + "static/media/Giddyapp_4.3e96ccdb.png";